enum View {
  Haves,
  Dashboard,
  GuiidePlus,
  You,
  Design,
  Test,
  Requirements,
  Life,
  Home,
  LowCostProviders,
  Finish,
  NoView,
  IFAPanel,
  Options,
  Integration,
  FAQ,
  Media,
  Login,
  UserHome,
  ForgotPassword,
  ResetForgottenPassword,
  ConfirmEmail,
  HowToCompleteDesign,
  DBOptions,
  Support,
  RetirementPassed
}

export default View;
